<div class="offcanvas offcanvas-end" id="memberTransactionOffcanvas" style="width: 60em">
  <div class="offcanvas-header">
    <h4 class="mb-0" id="offcanvasRightLabel">
      {{ "HISTORY_OF_CREDIT_INCREASE_DECREASE" | translate
      }}<span *ngIf="member">({{ member?.username }})</span>
    </h4>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
  </div>
  <div class="offcanvas-body">
    <div class="card">
      <div class="card-body">
        <div class="mb-2" *ngIf="member">
          {{ "BALANCE" | translate }} :
          <u>{{ member.wallet_seamless | number : "1.2-2" }} {{ member.currency }}</u>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ "TYPE" | translate }}</th>
                <th>{{ "BEFORE" | translate }}</th>
                <th>{{ "AMOUNT" | translate }}</th>
                <th>{{ "AFTER" | translate }}</th>
                <th>FROM</th>
                <th>{{ "CONFIRMED_BY" | translate }}</th>
                <th>{{ "CREATE_DATE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of transactionItems?.items; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <span *ngIf="item.action == 'add'">{{ "DEPOSIT" | translate }}</span>
                  <span *ngIf="item.action != 'add'">{{ "WITHDRAW" | translate }}</span>
                </td>
                <td>
                  {{ item.credit_before | number : "0.2-2" }}
                </td>
                <td class="text-end">
                  <span *ngIf="item.action === 'add'" class="badge badge-primary fs-5">
                    {{ item.amount | number : "0.2-2" }}
                  </span>
                  <span *ngIf="item.action === 'reduce'" class="badge badge-danger fs-5">
                    -{{ item.amount | number : "0.2-2" }}
                  </span>
                </td>
                <td>
                  {{ item.credit_after | number : "0.2-2" }}
                </td>
                <td>
                  <div class="text-uppercase">
                    {{ item.channel }}
                  </div>
                </td>
                <td>
                  <span *ngIf="item.channel == 'api'">
                    {{ item.ip_address }}
                  </span>
                  <span *ngIf="item.admin_name">{{ item.admin_name }}</span>
                </td>
                <td>
                  <app-show-date-time [date]="item.create_date"></app-show-date-time>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center mb-3">
          <div class="" *ngIf="transactionItems && !transactionItems?.items.length">
            {{ "NO_DATA" | translate }}
          </div>
          <div class="" *ngIf="loading"><span class="spinner-border"></span></div>
        </div>
        <app-pagination
          *ngIf="transactionItems"
          [(page)]="currentPage"
          [limit]="transactionItems.limitRow"
          [total]="transactionItems.resultRow"
          (valueChange)="pageChange($event)"
        >
        </app-pagination>
      </div>
    </div>
  </div>
</div>
